import "./index.scss";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@mui/material";
import { useState, useEffect } from "react";

const MaterialUITable = ({
  columnsList,
  dataList,
  pageCount,
  filters,
  onChange,
  onClick,
}) => {
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (Number.isInteger(parseInt(filters?.page))) {
      setPage(filters.page);
    }
  }, [filters?.page]);

  return (
    <>
      <TableContainer className={`con-scroll`}>
        <Table sx={{ minWidth: 650 }} stickyHeader>
          <TableHead>
            <TableRow>
              {columnsList?.map((head, index) => (
                <TableCell className="table-cell" key={index} align="center">
                  {head.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {dataList?.map((ele, index) => (
              <TableRow
                key={ele.key ? ele.key : index}
                // style={{ cursor: edit ? "pointer" : "context-menu" }}
              >
                {columnsList?.map((col, index) => {
                  const value = ele[col.key];
                  if (col.render) {
                    return (
                      <TableCell
                        key={col.key ? col.key : index}
                        align="center"
                        className="bd-table-cell"
                      >
                        {col.render(ele, onClick)}
                      </TableCell>
                    );
                  }
                  return (
                    <TableCell
                      key={col.key ? col.key : index}
                      align="center"
                      className="bd-table-cell"
                    >
                      {value}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="si-pagination">
        {pageCount > 1 && (
          <Pagination
            count={pageCount}
            color="primary"
            page={page}
            onChange={(e, page) => {
              setPage(page);
              if (onChange) {
                onChange(e, page);
              }
            }}
          ></Pagination>
        )}
      </div>
    </>
  );
};

export default MaterialUITable;
